import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, FormControlLabel, Checkbox } from '@mui/material';

const Locations = () => {
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [rows, setRows] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState({
    name: '',
    priceper: '',
    isLotRequired: false,
    allowNoteForLot: false,
    isSerialRequired: false,
    allowNoteForSerial: false,
  });

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await axios.get('https://hms.backend.hiragroupcloud.com/api/get-locations');
        const data = response.data; // Assuming the actual data is under data.data
  

        const formattedData = data.map(location => ({
          id: location._id, // Use _id for DataGrid row id
          name: location.valueName,
          priceper: location.isLotRequired ? 'Lot' : 'Serial',
          isLotRequired: location.isLotRequired ? true : false,
          allowNoteForLot: location.allowNoteForLot ? true : false,
          isSerialRequired: location.isSerialRequired ? true : false,
          allowNoteForSerial: location.allowNoteForSerial ? true : false,
        }));

        setRows(formattedData);
      } catch (error) {
        console.error('Error fetching locations:', error);
      }
    };

    fetchLocations();
  }, []);

  const handleEdit = (id) => {
    const rowData = rows.find(row => row.id === id); // Use row.id which is _id
    setSelectedRowData(rowData);
    setIsEditModalOpen(true);
  };

    // Delete selected row
    const handleDelete = async (id) => {
      try {
        const response = await axios.delete(`https://hms.backend.hiragroupcloud.com/api/deleteLocation/${id}`);

        if (response.data.success) {
          setRows(rows.filter(row => row.id !== id));
          setSelectedRowId(null);
        } else {
          console.error("Failed to delete the row:", response.data.message);
        }
      } catch (error) {
        console.error('There was an error deleting the data:', error);
      }
    };
  

  const handleRowClick = (id) => {
    setSelectedRowId(id === selectedRowId ? null : id);
  };

  const handleModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedRowData(null);
  };

  const handleSaveChanges = async () => {
    if (!selectedRowData) {
      console.error("Selected row data is missing");
      return;
    }

    try {
      const response = await axios.put(`https://hms.backend.hiragroupcloud.com/api/updateLocation/${selectedRowData.id}/`, selectedRowData);
      

      if (response.data.success) {
        const updatedRows = rows.map(row =>
          row.id === selectedRowData.id ? { ...row, ...selectedRowData } : row
        );
        setRows(updatedRows);
        setIsEditModalOpen(false);
        setSelectedRowData(null);
      } else {
        console.error("Failed to save changes:", response.data.message);
      }
    } catch (error) {
      console.error('There was an error saving the data:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedRowData(prevData => ({ ...prevData, [name]: value }));
  };

  const columns = [
    { field: 'name', headerName: 'Name', width: 200 },
    { field: 'priceper', headerName: 'Price per', width: 150, align: 'center', headerAlign: 'center' },
    {
      field: 'isLotRequired',
      headerName: 'Lot Required',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Checkbox checked={params.value} disabled />
      ),
    },
    {
      field: 'allowNoteForLot',
      headerName: 'Allow Note for Lot',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Checkbox checked={params.value} disabled />
      ),
    },
    {
      field: 'isSerialRequired',
      headerName: 'Serial Required',
      width: 150,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Checkbox checked={params.value} disabled />
      ),
    },
    {
      field: 'allowNoteForSerial',
      headerName: 'Allow Note for Serial',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Checkbox checked={params.value} disabled />
      ),
    },
  ];

  const [searchTerm, setSearchTerm] = useState('');
  const filteredRows = rows.filter(row =>
    Object.values(row).some(value =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  return (
    <>
      <h1 className="title">Location Rules</h1>
      <div style={{width:'1560px',margin:'0 auto',backgroundColor:'#f4f4f4',padding:"10px"}}>
      <div className="search">
        
        <div className="row align-items-center">
            <div className="col-md-6 d-flex justify-content-start">
              <input
                type="text"
                id="searchInput"
                className="form-control"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          <div className="col-md-6 d-flex justify-content-end">
            <Link to="/AddLocation" className="btn btn-primary" style={{backgroundColor:'#004aad',borderColor:'#004aad'}}>
              Add
            </Link>
          </div>
        </div>
      </div>

      <div style={{ height: 350, width: '100%', position: 'relative', marginTop: '2%', }}>
        <DataGrid
          rows={filteredRows}
          columns={columns}
          pageSize={5}
          rowSelected={selectedRowId !== null}
          onRowClick={(row) => handleRowClick(row.id)}
          components={{
            Toolbar: () => null,
          }}
          sx={{
            '& .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold',
            },
            '& .MuiDataGrid-cell:focus': {
              outline: 'none',
            },
            '& .MuiDataGrid-cell:focus-within': {
              outline: 'none',
            },
          }}
        />
        {selectedRowId !== null && (
          <div
            style={{
              position: 'absolute',
              top: rows.findIndex(row => row.id === selectedRowId) * 52 + 48,
              right: '10px',
              display: 'flex',
              marginTop: '15px'
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleEdit(selectedRowId)}
              sx={{ marginRight: 1 }}
            >
              Edit
            </Button>
            <Button
  variant="contained"
  sx={{ backgroundColor: 'red', '&:hover': { backgroundColor: '#c62828' } }}
  onClick={() => {
    
    handleDelete(selectedRowId);
  }}
>
  Delete
</Button>
          </div>
        )}
      </div>
      </div>

      {/* Edit Modal */}
      <Dialog open={isEditModalOpen} onClose={handleModalClose}>
        <DialogTitle>Edit Location</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Name"
            type="text"
            fullWidth
            name="name"
            value={selectedRowData?.name || ''}
            onChange={handleInputChange}
          />
          <TextField
            margin="dense"
            label="Price per"
            type="text"
            fullWidth
            name="priceper"
            value={selectedRowData?.priceper || ''}
            onChange={handleInputChange}
          />
          
          {/* Checkboxes for boolean fields */}
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedRowData?.isLotRequired === true}
                onChange={(e) =>
                  setSelectedRowData(prevData => ({
                    ...prevData,
                    isLotRequired: e.target.checked ? true : false,
                  }))
                }
                color="primary"
              />
            }
            label="Lot Required"
          />
          
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedRowData?.allowNoteForLot === true}
                onChange={(e) =>
                  setSelectedRowData(prevData => ({
                    ...prevData,
                    allowNoteForLot: e.target.checked ? true : false,
                  }))
                }
                color="primary"
              />
            }
            label="Allow Note for Lot"
          />
          
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedRowData?.isSerialRequired === true}
                onChange={(e) =>
                  setSelectedRowData(prevData => ({
                    ...prevData,
                    isSerialRequired: e.target.checked ? true : false,
                  }))
                }
                color="primary"
              />
            }
            label="Serial Required"
          />
          
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedRowData?.allowNoteForSerial === true}
                onChange={(e) =>
                  setSelectedRowData(prevData => ({
                    ...prevData,
                    allowNoteForSerial: e.target.checked ? true : false,
                  }))
                }
                color="primary"
              />
            }
            label="Allow Note for Serial"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleModalClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSaveChanges} color="primary">
            Save Change
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Locations;
